import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const STORAGE_KEY = "welcome_offer_dismissed_v1";

export default function WelcomeOfferBar() {
  const [hidden, setHidden] = useState(true);

  useEffect(() => {
    try {
      setHidden(window.localStorage.getItem(STORAGE_KEY) === "1");
    } catch {
      setHidden(false);
    }
  }, []);

  if (hidden) return null;

  const dismiss = () => {
    try { window.localStorage.setItem(STORAGE_KEY, "1"); } catch { /* ignore */ }
    setHidden(true);
  };

  return (
    <div
      data-testid="welcome-offer-bar"
      className="bg-primary text-primary-foreground border-b border-primary/40"
    >
      <div className="container-page flex items-center justify-center gap-3 py-2 text-[12px] sm:text-[13px] tracking-wide">
        <span className="hidden sm:inline font-bold uppercase tracking-[0.18em] text-accent">
          Welcome offer
        </span>
        <span className="sm:hidden font-bold uppercase tracking-[0.18em] text-accent">
          Offer
        </span>
        <span className="opacity-90">·</span>
        <span>
          Buy any 2 books — the cheaper one is{" "}
          <span className="font-semibold text-accent">50% off</span>.{" "}
          <Link to="/browse" className="underline underline-offset-2 hover:text-accent">
            Browse the catalogue
          </Link>
        </span>
        <button
          onClick={dismiss}
          data-testid="welcome-offer-dismiss"
          className="ml-3 opacity-70 hover:opacity-100 transition-opacity"
          aria-label="Dismiss"
        >
          <X className="h-3.5 w-3.5" strokeWidth={1.5} />
        </button>
      </div>
    </div>
  );
}
